import React, { useEffect } from "react";
import ChatwithMultipleUser from "../../../Common/ChatwithMultipleUser/ChatwithMultipleUser";
import PostNotFound from "../../../CustomComponents/AllLoader/PostNotFound";
import { useLocation } from "react-router-dom";

export default function ChatDetails({ selectUser, setselectUser }) {
  const location = useLocation();
  const { state } = location;
  const userdetails = state?.userdetails || null;

  useEffect(() => {
    if (userdetails !== null) {
      setselectUser({
        id: userdetails?.post_id  || "", 
        user_id: userdetails?.user_id,
      });
    }
  }, [userdetails]);
  
  return (
    <div style={{padding:"15px"}}>
      {selectUser == null ? (
        <PostNotFound title={"Select a chat to start messaging"} />
      ) : (
        <ChatwithMultipleUser selectUser={selectUser} />
      )}
    </div>
  );
}
